import { combineReducers } from 'redux';
import TokenReducer from './token';
import ThemeReducer from './theme';
import StyleReducer from './style';
export default combineReducers({
  token: TokenReducer,
  theme: ThemeReducer,
  style: StyleReducer
});